<template>
  <textarea type="text" v-model="model" class="form-textarea"></textarea>
</template>

 <script>
  export default {
    name: 'form-textarea',
    props: {
      value: {}
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$nextTick(() => {
            this.$emit('input', value)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  @import '../form-field-default.scss';

  .form-textarea {
    @include form-field-default;
    border: 1px solid #eee;

    &:focus {
      border-color: rgba(#000, .15);
    }
  }
</style>
